import React from 'react';
import { PushpayLogoIcon } from '@pushpay/iconography';
import { createUseStyles, clsx, multiply } from '@pushpay/styles';
import { footerHeight } from '../../common';
const useStyles = createUseStyles(theme => ({
  /**
   * The outer `footer` style.
   */
  root: {
    backgroundColor: theme.colors['color-background-surface'],
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    height: footerHeight,
    padding: multiply(theme.SPACING.GUTTER, 3),
    borderTop: `1px solid ${theme.colors['color-border-surface']}`,
    font: theme.TYPOGRAPHY.BODY_1,
    color: theme.colors['color-text-default'],
    [theme.mediaBreakpoint('TABLET_AND_BELOW')]: {
      justifyContent: 'space-between',
      font: theme.TYPOGRAPHY.BODY_2,
      padding: multiply(theme.SPACING.GUTTER, 2)
    },
    [theme.mediaQuery({
      mediaType: 'PRINT'
    })]: {
      display: 'none'
    }
  },

  /**
   * The style for the Pushpay logo.
   */
  pushpayLogo: {
    fontSize: '2em'
  },

  /**
   * The style for the copyright text.
   */
  text: {
    paddingLeft: `${multiply(theme.SPACING.GUTTER, 3)}`
  }
}));

const FooterCap = props => {
  const {
    classes: classesProp,
    className: classNameProp,
    'data-pp-at-target': targetId,
    year
  } = props;
  const classes = useStyles(classesProp);
  const className = clsx(classes.root, classNameProp);
  return /*#__PURE__*/React.createElement("footer", {
    className: className
  }, /*#__PURE__*/React.createElement(PushpayLogoIcon, {
    "data-pp-at-target": `${targetId}-PushpayLogo`,
    className: classes.pushpayLogo
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.text
  }, `© ${year} Pushpay® Ltd.`));
};

export default FooterCap;